import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { bootstrapTheme } from './lib/theme';
import './styles/global.css';

bootstrapTheme();

const root = document.getElementById('root');
if (!root) throw new Error('#root not found in index.html');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
